import { render, staticRenderFns } from "./NgVideo.vue?vue&type=template&id=3b4b107a&scoped=true&"
import script from "./NgVideo.vue?vue&type=script&lang=js&"
export * from "./NgVideo.vue?vue&type=script&lang=js&"
import style0 from "./NgVideo.vue?vue&type=style&index=0&id=3b4b107a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b107a",
  null
  
)

export default component.exports